import { useEventInfo } from './useEventInfo';
import { useIsNewStackEvent } from './useIsNewStackEvent';
import { resolveGuestIdentity } from './guestIdentity';
import type { GuestIdentity } from './guestIdentity.types';

/**
 * Deliberately NOT re-exported from `@shared/utils/eventInfo`, for the same reason as
 * `useIsNewStackEvent` and the route hooks it sits beside: many specs factory-mock that barrel.
 */
export const useGuestIdentity = (): GuestIdentity => {
  // `loading` here is the provider's already-data-gated flag, not a raw Apollo one — see the note in
  // `resolveGuestIdentity`. Consumers gate destructive work on `!== 'loading'`, so a flag that went
  // true on every refetch would make them thrash.
  const { eventInfo, loading } = useEventInfo();
  const isNewStackEvent = useIsNewStackEvent();

  return resolveGuestIdentity({ eventType: eventInfo?.eventType, isNewStackEvent, isLoading: !!loading });
};
